export enum UserType {
  Master = 'master',
  ClientAdmin = 'client_admin',
  UserFilial = 'user_filial',
}
